import styles from "./PresentersFilters.module.css";
import React, { memo } from "react";
import { Checkbox, createStyles, FormControlLabel, makeStyles, Theme } from "@material-ui/core";
import { useSelector } from "react-redux";
import { AppState } from "../../../../root/RootReducer";
import { AnimatePresence, motion } from "framer-motion";
import PuiTypography from "../../../../components/elements/PuiTypography";
import classNames from "classnames";
import PuiTooltip from "../../../../components/elements/PuiTooltip ";
import CheckboxIcon from "../../../../common/components/images/CheckboxIcon";
import CheckboxCheckedIcon from "../../../../common/components/images/CheckboxCheckedIcon";
import useResponsive from "../../../../common/useResponsive";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    filterCheckBox: {
      marginLeft: theme.spacing(1),
      marginBottom: "-8px",
    },
    filterTabletCheckBox: {
      marginLeft: theme.spacing(1),
      marginBottom: "-8px",
      marginRight: 0,
    }
  })
);

interface checkObject {
  [key: string]: boolean;
}

interface PresentersFiltersProps {
  anime: boolean;
  checkedSkills: checkObject;
  checkedTags: checkObject;
  changeSkillFilter: (event: React.ChangeEvent<HTMLInputElement>) => void;
  changeTagFilter: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function PresentersFilters(props: PresentersFiltersProps) {
  const classes = useStyles();

  const { skills, tags } = useSelector((state: AppState) => ({
    skills: state.presenters.index.skills,
    tags: state.presenters.index.tags,
  }));

  const { isMobile, isTablet } = useResponsive();

  const { anime, checkedSkills, checkedTags, changeSkillFilter, changeTagFilter } = props;

  const contents = (
    <>
      <div className={styles.header}>
        <PuiTypography size={isMobile ? 16 : 20} bold={true}>
          Presenter Skills
        </PuiTypography>
      </div>
      <div className={styles.list}>
        {skills &&
          skills.map((skill, index) => (
            <div key={index} className={styles.filterCheckbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    icon={
                      <div className={styles.checkedIcon}>
                        <CheckboxIcon />
                      </div>
                    }
                    checkedIcon={
                      <div className={styles.checkedIcon}>
                        <CheckboxCheckedIcon />
                      </div>
                    }
                    checked={checkedSkills[skill] || false}
                    onChange={changeSkillFilter}
                    name={skill}
                  />
                }
                label={
                  <>
                    <div className={styles.filterCheckboxTag} data-tip={skill} data-for="skill">
                      <PuiTypography size={isMobile ? 14 : 16}>{skill}</PuiTypography>
                    </div>
                    <PuiTooltip id="skill" />
                  </>
                }
                className={isTablet ? classes.filterTabletCheckBox : classes.filterCheckBox}
              />
            </div>
          ))}
      </div>
      <div className={styles.header}>
        <PuiTypography size={isMobile ? 16 : 20} bold={true}>
          Tags
        </PuiTypography>
      </div>
      <div className={classNames(styles.list)}>
        {tags &&
          tags.map((tag, index) => (
            <div key={index} className={styles.filterCheckbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    icon={
                      <div className={styles.checkedIcon}>
                        <CheckboxIcon />
                      </div>
                    }
                    checkedIcon={
                      <div className={styles.checkedIcon}>
                        <CheckboxCheckedIcon />
                      </div>
                    }
                    checked={checkedTags[tag] || false}
                    onChange={changeTagFilter}
                    name={tag}
                  />
                }
                label={
                  <>
                    <div className={styles.filterCheckboxTag} data-tip={tag} data-for="tag">
                      <PuiTypography size={isMobile ? 14 : 16}>{tag}</PuiTypography>
                    </div>
                    <PuiTooltip id="tag" />
                  </>
                }
                className={isTablet ? classes.filterTabletCheckBox : classes.filterCheckBox}
              />
            </div>
          ))}
      </div>
    </>
  );

  return (
    <AnimatePresence>
      {anime ? (
        <motion.div
          key="animated-filters"
          initial={{ x: -20 }}
          animate={{ x: 0 }}
          exit={{ x: 20 }}
          transition={{ ease: "easeOut", duration: 0.5 }}
          className={styles.filters}
        >
          {contents}
        </motion.div>
      ) : (
        <div key="static-filters" className={styles.filters}>
          {" "}
          {/* 为静态 div 也添加 key */}
          {contents}
        </div>
      )}
    </AnimatePresence>
  );
}

export default memo(PresentersFilters);
